import { Avatar, Stack } from "@mui/material";

const UpgradePlanCard = ({ nameProfile, ref, ac, ah, sx }: any) => {
  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: "secondary",
        fontSize: "20px",
      },
      children: `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}`,
    };
  }
  return (
    <Stack direction="row">
      <Avatar {...stringAvatar(nameProfile)} ref={ref} aria-controls={ac} aria-haspopup={ah} sx={sx} />
    </Stack>
  );
};

export default UpgradePlanCard;
